import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, Image, LinkData, Spacing, TextInput } from '../../types'
import { CmsConverterService, defaultLinkData, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class PanelRowPdfTeaserXlConverter extends CmsConverterService<PanelRowPdfTeaserXlData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData?.st_panel_row_pdf_image_alternative_text?.value
    const lazyLoad = formData.st_lazy_load_image?.value
    return {
      link: formData.st_document_link ?? defaultLinkData,
      text: formData.st_panel_row_text ?? defaultTextInput,
      flowingText: formData?.st_flowing_text?.value ?? false,
      image: CmsConverterService.mapImage(formData.st_panel_row_pdf_image_normal_reference, lazyLoad, altText),
      pdfTitle: formData.st_document_link?.value?.formData?.lt_reference?.value?.resolutions?.fileName?.replace('_', ' ') ?? '',
      spacing: {
        top: formData.st_spacing_top?.value?.identifier ?? '',
        bottom: formData.st_spacing_bottom?.value?.identifier ?? ''
      }
    }
  }
}

export const PANEL_ROW_PDF_TEASER_XL_CONVERTER_TOKEN =
  new InjectionToken<Converter<CmsComponent, PanelRowPdfTeaserXlData>>('PanelRowPdfTeaserConverter')

export interface PanelRowPdfTeaserXlData extends ConvertedComponentData {
  link: LinkData;
  text: TextInput;
  image: Image;
  pdfTitle: string;
  spacing: Spacing;
  flowingText: boolean;
}

